export default {
    "MIME-Version": "1.0",
    "Content-Type": "text/plain; charset=utf-8",
    "Content-Transfer-Encoding": "8bit",
    "X-Generator": "Ideo Core",
    "Language": "en-US",
    "Messages": {
        "%0": "%0",
        "1K tokenów": "1K tokens",
        "1M tokenów": "1M tokens",
        "Aby połączenie z API OpenAI zostało nawiązane, należy podać klucz wygenerowany na stronie producenta i wybrać wersję modelu. Połączenie z API jest sprawdzane przy zapisie formularza.": "To establish connection with OpenAI API, provide key generated on provider's website and select model version. API connection are checked when saving form.",
        "Aby przejść do następnego kroku, użyj przycisku \"Następny krok\".": "To go to next step, use \"Next step\" button.",
        "Adres API": "API address",
        "Aktywuj AI": "Enable AI",
        "Aktywuj Asystenta AI": "Enable AI Assistant",
        "Aktywuj czat AI": "Enable AI chat",
        "Aktywuj funkcjonalności AI": "Enable AI features",
        "Aktywuj inteligentne usługi oparte o sztuczną inteligencję.": "Enable intelligent services based on artificial intelligence.",
        "Aktywuj inteligentnego asystenta opartego o sztuczną inteligencję.": "Enable intelligent assistant based on artificial intelligence.",
        "Aktywuj możliwości narzędzi OpenAI.": "Enable OpenAI tool capabilities.",
        "Aktywuj OpenAI": "Enable OpenAI",
        "Asystent": "Assistant",
        "Asystent AI": "AI Assistant",
        "Asystent został pomyślnie utworzony.": "Assistant has been created successfully.",
        "Asystent został pomyślnie zainicjalizowany.": "Assistant has been initialized successfully.",
        "Azure OpenAI": "Azure OpenAI",
        "Brak danych do wyświetlenia": "No data to display",
        "Brak kategorii": "No category",
        "Brak materiałów": "No materials",
        "Brak ograniczenia": "No limit",
        "Cennik Azure OpenAI": "Azure OpenAI pricing",
        "Cennik OpenAI": "OpenAI pricing",
        "Choices": "Choices",
        "Created": "Created",
        "Czat AI": "AI chat",
        "DALL-E 3": "DALL-E 3",
        "DALLE-3": "DALLE-3",
        "Dane wejściowe": "Input data",
        "Dane wyjściowe": "Output data",
        "Dodaj lekcję": "Add lesson",
        "Dodaj model": "Add model",
        "Dodaj test": "Add test",
        "Domyślny": "Default",
        "Dostawca": "Provider",
        "Dostawca jest wymagany": "Provider is required",
        "Embedding": "Embedding",
        "Etykieta": "Label",
        "Funkcjonalności AI": "AI features",
        "Generator dynamicznych formularzy włączony": "Dynamic form generator enabled",
        "Generator dynamicznych formularzy wyłączony": "Dynamic form generator disabled",
        "Generator metadanych obrazu włączony": "Image metadata generator enabled",
        "Generator metadanych obrazu wyłączony": "Image metadata generator disabled",
        "Generator metadanych SEO włączony": "SEO metadata generator enabled",
        "Generator metadanych SEO wyłączony": "SEO metadata generator disabled",
        "Generator obrazów włączony": "Image generator enabled",
        "Generator obrazów wyłączony": "Image generator disabled",
        "Generowanie planu szkolenia rozpoczęte": "Training plan generation started",
        "Generowanie szkolenia zostało rozpoczęte, może to potrwać kilka minut.": "Training generation has started, this may take a few minutes.",
        "Generuj plan kursu": "Generate course plan",
        "Generuj szkolenie": "Generate training",
        "GPT-4 Turbo": "GPT-4 Turbo",
        "GPT-4o": "GPT-4o",
        "GPT-4o mini": "GPT-4o mini",
        "GPT-4o Mini": "GPT-4o Mini",
        "Historia": "History",
        "Id": "Id",
        "Id dokumentu nadrzędnego Outline": "Outline parent document Id",
        "Id slajdu": "Slide Id",
        "Identity": "Identity",
        "Identyfikator odpowiedzi.": "answer identifier.",
        "Identyfikator slajdu": "Slide identifier",
        "Identyfikator zapytania": "Query identifier",
        "Inteligentne narzędzie generujące dynamiczne formularze.": "Intelligent tool for generating dynamic forms.",
        "Inteligentne narzędzie generujące metadane obrazu.": "Intelligent tool for generating image metadata.",
        "Inteligentne narzędzie generujące metadane SEO.": "Intelligent tool for generating SEO metadata.",
        "Inteligentne narzędzie generujące obrazy.": "Intelligent tool for generating images.",
        "Inteligentne narzędzie wskazujące najbardziej trafny wynik wyszukiwania.": "Intelligent tool indicating most relevant search result.",
        "Inteligentny czas posiadający wiedzę na tematu systemu Edito.": "Intelligent chat with knowledge about Edito system.",
        "Jakość HD": "HD quality",
        "Jakość standardowa": "Standard quality",
        "Kategoria szkolenia": "Training category",
        "Klucz API": "API key",
        "Klucz Azure Open AI API": "Azure Open AI API key",
        "Klucz Outline API": "Outline API key",
        "Konfiguracja AI": "AI configuration",
        "Konfiguracja Asystenta AI nieprawidłowa": "AI Assistant configuration is invalid",
        "Konfiguracja Asystenta AI prawidłowa": "AI Assistant configuration is valid",
        "Krok 1": "Step 1",
        "Krok 2": "Step 2",
        "Krok 3": "Step 3",
        "Label musi mieć co najmniej 3 znaki": "Label must be at least 3 characters",
        "Label nie może być dłuższy niż 100 znaków": "Label cannot exceed 100 characters",
        "Lekcja": "Lesson",
        "Limit API": "API limit",
        "Limit jest potrzebny do poprawnego wyświetlenia statystyk zużycia na stronie głównej panelu. Nie jest powiązany z limitem konta.": "Limit is needed to correctly display usage statistics on home page of panel. It is not related to account limit.",
        "Link": "Link",
        "Lista możliwości zakończenia czatu. W obecnym stanie model zwraca jedną możliwą odpowiedź.": "List of chat completion options. In current state, model returns one possible answer.",
        "Lista wiadomości (prompt) składających się na dotychczasową konwersację z modelem.": "List of messages (prompt) making up conversation with model so far.",
        "Maksymalna liczba tokenów": "Maximum number of tokens",
        "Max tokens": "Max tokens",
        "Messages": "Messages",
        "Model": "Model",
        "Model generuje odpowiedź na podstawie podanych przez użytkownika parametrów.": "Model generates answer based on parameters provided by user.",
        "Moderacja włączona": "Moderation enabled",
        "Moderacja wyłączona": "Moderation disabled",
        "Moderacjia danych wejściowych jest zalecana.": "Input data moderation are recommended.",
        "Mowa": "Speech",
        "Na podstawie dołączonych plików oraz zaproponowanego planu zostanie utworzone szkolenie.": "Training will be created based on attached files and proposed plan.",
        "Na podstawie dołączonych plików zostanie zaproponowany plan szkolenia.": "Training plan will be proposed based on attached files.",
        "Narzędzia AI": "AI tools",
        "Następny krok": "Next step",
        "Nazwa": "Name",
        "Nazwa musi mieć co najmniej 2 znaki": "Name must be at least 2 characters",
        "Nazwa nie może być dłuższa niż 50 znaków": "Name cannot exceed 50 characters",
        "Nazwa pliku": "File name",
        "Nazwa szkolenia": "Training name",
        "Nazwa wdrożenia chatu": "Chat deployment name",
        "Nazwa wdrożenia embeddingów": "Embedding deployment name",
        "Nie udało się pobrać kategorii.": "Failed to fetch category.",
        "Nie udało się pobrać lub przygotować asystenta. Próba utworzenia nowego asystenta...": "Failed to fetch or prepare assistant. Attempting to create new assistant...",
        "Nie udało się powiązać plików z asystentem AI.": "Failed to link files with AI Assistant.",
        "Nie udało się utworzyć asystenta.": "Failed to create assistant.",
        "Nie udało się utworzyć i zainicjalizować asystenta.": "Failed to create and initialize assistant.",
        "Nie udało się utworzyć szkolenia.": "Failed to create training.",
        "Nie udało się wygenerować planu kursu.": "Failed to generate course plan.",
        "Nie udało się zacząć generowania planu.": "Failed to start plan generation.",
        "Niepoprawny format wygenrowanego planu szkolenia": "Invalid format of generated training plan",
        "NOWOŚĆ": "NEW",
        "Object": "Object",
        "Obrazy": "Images",
        "Odpowiedź": "answer",
        "Ograniczna wygenerowaną odpowiedź do podanej liczby tokenów.": "Limit generated answer to specified number of tokens.",
        "OpenAI": "OpenAI",
        "OpenAI o1": "OpenAI o1",
        "OpenAI o1-mini": "OpenAI o1-mini",
        "Parameters": "Parameters",
        "Parametry": "Parameters",
        "Plan kursu został wygenerowany.": "Course plan has been generated.",
        "Plik został pomyślnie przesłany do asystenta AI.": "File has been uploaded to AI Assistant successfully.",
        "Pliki zostały pomyślnie powiązane z asystentem AI.": "Files have been linked with AI Assistant successfully.",
        "Pliki zostały przetworzone": "Files have been processed",
        "Po zaznaczeniu opcji, plan szkolenia zostanie wygenerowany na podstawie dołączonych plików.": "If option is selected, training plan will be generated based on attached files.",
        "Podaj nazwę szkolenia.": "Provide training name.",
        "Podaj symbol strony szkolenia.": "Provide training page symbol.",
        "Połączenie z API OpenAI jest aktywne.": "Connection with OpenAI API are active.",
        "Połączenie z API OpenAI jest nieaktywne.": "Connection with OpenAI API are inactive.",
        "Potwierdzenie usunięcia": "delete confirmation",
        "Powrót": "back",
        "Proszę czekać, trwa generowanie planu szkoleń.": "Please wait, training plan generation is in progress.",
        "Proszę czekać, trwa inicjalizacja asystenta AI.": "Please wait, AI Assistant initialization is in progress.",
        "Prywatny klucz Langfuse": "Langfuse private key",
        "Przekroczono czas oczekiwania na dane asystenta.": "Timeout while waiting for assistant data.",
        "Przepisz aktualne stawki za milion tokenów z cennika Azure OpenAI.": "Rewrite current rates per million tokens from Azure OpenAI pricing.",
        "Przepisz aktualne stawki za milion tokenów z cennika OpenAI.": "Rewrite current rates per million tokens from OpenAI pricing.",
        "Przepisz aktualne stawki za tysiąc tokenów z cennika Azure OpenAI.": "Rewrite current rates per thousand tokens from Azure OpenAI pricing.",
        "Przepisz aktualne stawki za tysiąc tokenów z cennika OpenAI.": "Rewrite current rates per thousand tokens from OpenAI pricing.",
        "Przetestuj": "Test",
        "PRZYKŁADOWY PROMPT": "SAMPLE PROMPT",
        "Publiczny klucz Langfuse": "Langfuse public key",
        "Rozdzielczość obrazu: 1024x1024": "Image resolution: 1024x1024",
        "Rozdzielczość obrazu: 1024x1792 lub 1792x1024": "Image resolution: 1024x1792 or 1792x1024",
        "Scorm": "Scorm",
        "Status": "Status",
        "Statystyki wykorzystania tokenów.": "Token usage statistics.",
        "Stwórz": "Create",
        "Suma zużytych tokenów": "Total used tokens",
        "Symbol może składać się tylko z małych liter, cyfr oraz znaku - ": "Symbol may contain only lowercase letters, digits, and - character ",
        "Symbol strony szkolenia": "Training page symbol",
        "Synchronizuj": "Synchronize",
        "Szczegóły zapytania OpenAI": "OpenAI query details",
        "Szkolenie zostało wygenerowane.": "Training has been generated.",
        "Tekst": "Text",
        "Temat": "Subject",
        "Test": "Test",
        "Test konfiguracji przeszedł pomyślnie": "Configuration test completed successfully",
        "Test konfiguracji przeszedł z ostrzeżeniami": "Configuration test completed with warnings",
        "Test konfiguracji zakończył się niepowodzeniem": "Configuration test failed",
        "Test ustawień": "Settings test",
        "Test ustawień pomyślnie zakończony.": "Settings test completed successfully.",
        "Tokeny łącznie": "Total tokens",
        "Tokeny odpowiedzi": "answer tokens",
        "Tokeny zapytania": "Query tokens",
        "Trwa generowanie planu szkolenia, może to potrwać kilka minut.": "Training plan generation is in progress, this may take a few minutes.",
        "Trwa testowanie konfiguracji...": "Configuration testing is in progress...",
        "tutaj": "here",
        "Typ": "Type",
        "Typ danych": "Data type",
        "Typ musi być jedną z dozwolonych wartości": "Type must be one of allowed values",
        "Typ obiektu.": "Object type.",
        "Uniksowy znacznik czasu utworzenia zakończenia czatu.": "Unix timestamp of chat completion creation.",
        "URL zasobu Azure AI": "Azure AI resource URL",
        "Usage": "Usage",
        "Ustawienia": "Settings",
        "Ustawienia Asystenta AI zostały zapisane.": "AI Assistant settings have been saved.",
        "Ustawienia chatu zostały zapisane.": "Chat settings have been saved.",
        "Ustawienia zostały zapisane.": "Settings have been saved.",
        "Usuń": "delete",
        "Usuń model": "delete model",
        "Usuń plik": "delete file",
        "Uzupelnij dane kursu, aby zaproponować plan szkolenia.": "Complete course data to propose training plan.",
        "Uzupełnij stronę publikacji i język.": "Complete publication page and language.",
        "Uzupełnij wytyczne dla Kreatora szkoleń.": "Complete guidelines for Training Creator.",
        "Video": "Video",
        "Wersja": "Version",
        "Wersja API": "API version",
        "Wersja jest wymagana": "Version is required",
        "Wersja modelu": "Model version",
        "Wersja modelu GPT.": "GPT model version.",
        "Wersja nie może być dłuższa niż 20 znaków": "Version cannot exceed 20 characters",
        "Wizja": "Vision",
        "Właściciel": "Owner",
        "Właściciel musi mieć co najmniej 2 znaki": "Owner must be at least 2 characters",
        "Właściciel nie może być dłuższy niż 50 znaków": "Owner cannot exceed 50 characters",
        "Właściwości": "Properties",
        "wybierz": "select",
        "Wybierz dostępne pliki": "Select available files",
        "Wybierz kategorię szkolenia.": "Select training category.",
        "wybierz model": "select model",
        "Wybierz nowe pliki z komputera": "Select new files from computer",
        "Wybierz przynajmniej jeden plik z bazy wiedzy lub dodaj plik z komputera.": "Select at least one file from knowledge base or add file from computer.",
        "Wybierz stronę nadrzędną szkolenia.": "Select parent training page.",
        "wybierz wersję": "select version",
        "Wyczyść wszystkie": "Clear all",
        "Wygenerowane szkolenie znajdziesz ": "You will find generated training ",
        "Wygeneruj plan szkolenia zanim przejdziesz dalej.": "Generate training plan before proceeding.",
        "Wyszukiwarka włączona": "Search engine enabled",
        "Wyszukiwarka wyłączona": "Search engine disabled",
        "Wytyczne dla Kreatora szkoleń": "Guidelines for Training Creator",
        "Z komputera": "From computer",
        "Zaktualizowano model asystenta do bieżącej konfiguracji AI.": "Assistant model has been updated to current AI configuration.",
        "Zapisz": "Save",
        "Zapytanie": "Query",
        "Zobacz szczegóły": "View details",
        "Zużyte tokeny": "Used tokens"
    }
};
